<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
        <h6>
          {{ isFormView ? 'Registrar detalle actualizar precios por c.costos'
          : 'Detalle actualizar precios por c.costos'}}
        </h6>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex justify-content-end">
        <app-custom-button tom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
          (onClick)="openCostCenterModal()" [width]="'6.5rem'"></app-custom-button>
        <app-custom-modal #costCenter [label]="'Nuevo Detalle'" [header]="'Selección de c.costos'" [width]="'80vw'"
          [children]="component" [inputs$]="inputsForCostCenter$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden>
        </app-custom-modal>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [showCheckbox]="!disabledDetail"
        [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
        (onRecoverData)="getUpdateCostCenterPriceDetailsForCaptureTable()" (onPageChange)="onPageChange($event)"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>